import React, { useEffect, useState } from 'react';
import './About.css';

const About = () => {
  const [aboutData, setAboutData] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/home-page`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": `${process.env.REACT_APP_API_URL_USERNAME}`,
        "api-password": `${process.env.REACT_APP_API_URL_PASSWORD}`
      },
      body: JSON.stringify({})
    })
      .then((response) => response.json())
      .then((data) => {
        setAboutData(data.home_page_about);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <section className="about-section section-pad" id="about">
      <div className="container">
        <div className="row align-items-center g-5">

          {/* ── Left: Image ── */}
          <div className="col-lg-5" data-aos="fade-right" data-aos-duration="800">
            <div className="about-img-wrapper">
              <img
                src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${aboutData.folder_path}/${aboutData.image}`}
                alt="Business team collaboration"
                className="about-img"
              />

              {/* Overlay Card — bottom-left */}
              {/* <div className="about-customer-card">
                <p className="customer-referral-text">
                  {aboutData.image_text}
                </p>
              </div> */}
              {/* Decorative shape */}
              <div className="about-shape-circle" />
            </div>
          </div>

          {/* ── Right: Content ── */}
          <div className="col-lg-7" data-aos="fade-left" data-aos-duration="800" data-aos-delay="100">
            <div className="about-content">
              <div
                dangerouslySetInnerHTML={{
                  __html: aboutData.description || ""
                }}
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;
